import cryptoApp from "../assets/images/cryptoApp.png";
import acmeRockets from "../assets/images/acmeRockets.png";
import realEstate from "../assets/images/realEstate.png";
import memeGenerator from "../assets/images/memeGenerator.png";
import budgetApp from "../assets/images/budgetApp.png";
import ecommerceApp from "../assets/images/ecommerceApp.png";
export const project_list = [
  {
    id: 1,
    image: ecommerceApp,
    name: "Ecommerce Store",
    description:
      "This app lets users browse separate categories for men and women, use a search bar to find specific products, add or remove items from the cart, and view the total price. It also suggests related products and includes a simple checkout form.",
    ghlink: "https://github.com/Bushra-naeem/ecommerce-store",
    demolink: "https://shopix-ecommerce-app.netlify.app/",
  },
  {
    id: 2,
    image: budgetApp,
    name: "Budget App",
    description:
      "This is a simple budget app built using React. It allows users to add different budgets, add expenses to the current budgets, display all budgets, display expenses, delete budgets & expenses, and offers functionality to get total budgets and expenses.",
    ghlink: "https://github.com/Bushra-naeem/react-budget-app",
    demolink: "https://budget-application-react.netlify.app/",
  },
  {
    id: 3,
    image: cryptoApp,
    name: "Crypto App",
    description:
      "This app uses cryptocurrency APIs to provide real-time data across three main pages: Crypto, Trending, and Saved. The Crypto page lists various cryptocurrencies, the Trending page showcases popular coins, and the Saved page lets users save their favorites.",
    ghlink: "https://github.com/Bushra-naeem/react-crypto-app",
    demolink: "https://crypto-application-react.netlify.app/",
  },
  {
    id: 4,
    image: realEstate,
    name: "Real Estate Website",
    description:
      "Homeverse, built with React.js and TailwindCSS, features a multi-page, fully responsive real estate website.",
    ghlink: "https://github.com/Bushra-naeem/real-estate-website",
    demolink: "https://react-real-estate-website.netlify.app/",
  },
  {
    id: 5,
    image: acmeRockets,
    name: "Acme Rockets Website",
    description:
      "A responsive website with user-friendly interface. It has smooth scrolling and multiple sections like Home, Our rockets, Testimonials and Contact Us",
    ghlink: "https://github.com/Bushra-naeem/acme-rockets",
    demolink: "https://acme-rockets-web.netlify.app/",
  },
  {
    id: 6,
    image: memeGenerator,
    name: "Meme Generator",
    description:
      "This project consists of a React Meme Generator app that allows the user to add two text inputs to a meme image and generating a custom meme, allowing the user to always change the image.",
    ghlink: "https://github.com/Bushra-naeem/react-meme-generator",
    demolink: "https://react-meme-maker-app.netlify.app/",
  },
];
